'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { i18n } from 'react-i18n'

const STYLES = {
    headerPurpose:{
        marginBottom: '0px',
        lineHeight: '1.3',
    },
    headerDonationId:{
      marginTop: '0px',
      lineHeight: '1.3',
    }
}

export default React.createClass({

    mixins: [i18n('common/subHeader')],

    propTypes:{
        label: React.PropTypes.string
    },

    getInitialState () {
        return {};
    },

    render () {

        let donateto = this.i18n('label.donateto');
        let purposeLabel = this.i18n('label.purpose');
        let donationName = this.props.label;
        let orgName = this.props.orgName;
        let donationId = this.props.donationId;
        let { formatedDonationName, formatedOrgName, formatedDonationId } =  {};

        if (donationName === orgName) {
          formatedDonationName = donationName;
          formatedOrgName = '';
        } else {
          formatedDonationName = donationName
        }

        if (orgName && !donationId) {
          if (donationName !== orgName) {
            formatedOrgName = `${purposeLabel} ${orgName}`;
          }
        }

        if (!orgName && donationId) {
          formatedDonationId = `${purposeLabel} ${donationId}`;
        }

        if (orgName && donationId) {
          if (donationName !== orgName) {
            formatedOrgName = `${purposeLabel} ${orgName}`;
            formatedDonationId =  donationId;
          } else {
            formatedOrgName = '';
            formatedDonationId = `${purposeLabel} ${donationId}`;
          }
        }

        return (
        	<div className="col-xs-12 col-sm-12 col-md-12 donate_sub_header">
            <h4 className="text-center h4one" id="headerDonateTo">{donateto}</h4>
            <h4 className="text-center h4two" id="headerDonateToName">{formatedDonationName}</h4>
            {formatedOrgName && <h5 className="text-center" style={STYLES.headerPurpose}>{formatedOrgName}</h5>}
            {formatedDonationId && <h5 className="text-center" style={STYLES.headerDonationId}>{formatedDonationId}</h5>}
        	</div>
        );
    }
});



// WEBPACK FOOTER //
// ./common/subHeader.js